import React, {PropTypes} from 'react';
import { Link } from 'react-router';
import DateTimeFormatter from '../DateTimeFormatter';
import HeaderImage from '../common/HeaderImage';
import './event.scss';

const EventCard = ({card, loading}) => {
  // const savingsExist = NumberFormatter.scrubFormatting(savings.monthly) > 0;
  // const savingsClass = savingsExist ? 'savings' : 'loss';
  // const resultLabel = savingsExist ? 'Savings' : 'Loss';
  let cardWrapperClasses = 'col-sm-6 col-lg-4 event-card';
  if(loading === true) {
    cardWrapperClasses += ' disable-while-loading';
  }

  return (
    <div className={cardWrapperClasses}>
      <div className="panel panel-default">
        <Link to={"/arrangement/" + card.id}>
        <HeaderImage
          headerLink={card.image_thumbnail}/>
        </Link>
        <div className="panel-body">
          <Link to={"/arrangement/" + card.id}>
            <h4 className="event-name">{card.name}</h4>
          </Link>
          <div className="event-description">
            {card.description && card.description.replace(/(<([^>]+)>)/ig,"")}
          </div>
          <hr/>
          <div className="row">
            <div className="col-xs-6">
              <DateTimeFormatter value={card.start_date} title="Startdato: " hide={false}/>
            </div>
            <div className="col-xs-6">
              <DateTimeFormatter value={card.end_date} title="Sluttdato: " hide={false} />
            </div>
          </div>
        </div>
        <div className="panel-footer">
          <DateTimeFormatter value={card.first_registration_deadline}
            title="Påmeldingsfrist: " hide={false} />
        </div>
      </div>
    </div>
  );
};

// Note that this odd style is utilized for propType validation for now. Must be defined *after*
// the component is defined, which is why it's separate and down here.
EventCard.propTypes = {
  card: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default EventCard;



/** WEBPACK FOOTER **
 ** ./src/components/event/EventCard.js
 **/